import { fetchItem } from 'common/api/financierProduct';

import {
    FETCH_PRODUCT,
    FETCH_PRODUCT_FAILURE,
    FETCH_PRODUCT_SUCCESS,
} from '../actionTypes';
import getConfig from '../partners/getConfig';
import { actions } from '../reducer';

import initializeForm from './initializeForm';
import resetForm from './resetForm';
import toggleModalProduct from './toggleModalProduct';

export default (value) => (dispatch) => {
    const { financier, id } = value;

    if (!financier || !id) return;

    dispatch(actions[FETCH_PRODUCT]());

    fetchItem(id)
        .then((response) => {
            const values = response.data;
            dispatch(actions[FETCH_PRODUCT_SUCCESS](values));

            const { getPrepareUpdateValues } = getConfig(financier);
            const initialValues = getPrepareUpdateValues({
                ...values,
                disabled: value.disabled,
            });

            dispatch(resetForm());
            dispatch(initializeForm(initialValues));
            dispatch(toggleModalProduct(true));
        })
        .catch((error) =>
            dispatch(
                actions[FETCH_PRODUCT_FAILURE](error?.response?.data?.errors),
            ),
        );
};
